import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import UserRegModal from "../../../../modal/PC/gijun/UserRegModal";
import UserUpdateModal from "../../../../modal/PC/gijun/UserUpdateModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import { useNavigate, useLocation } from "react-router-dom";

const User = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState();
    const [columns, setColumns] = useState([]);
    const [deptOption, setDeptOption] = useState([]);
    const [workplaceOption, setWorkplaceOption] = useState([]);
    const [positionOption, setPositionOption] = useState([]);
    const [dutyOption, setDutyOption] = useState([]);
    const [bankOption, setBankOption] = useState([]);
    const [deptModalOption, setDeptModalOption] = useState([]);
    const [workplaceModalOption, setWorkplaceModalOption] = useState([]);
    const [positionModalOption, setPositionModalOption] = useState([]);
    const [dutyModalOption, setDutyModalOption] = useState([]);
    const [bankModalOption, setBankModalOption] = useState([]);
    const [keyword, setKeyword] = useState({
        workplace_id:0,
        dept_id:0,
        position:0,
        duty:0
    });
    const [isRegModalOpen, setRegModalOpen] = useState(false);
    const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectUserID, setSelectUserID] = useState('');
    
    // Grid정의
    const handleSetting = () => {
        setColumns([
            (MenuUpdateExistYN === "Y"?
            {
                field: 'updated',
                headerName: '수정',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<EditIcon color="primary" />} onClick={() => {UpdateClick(params)}} label="Edit" />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            (MenuDeleteExistYN === "Y"?
            {
                field: 'deleted',
                headerName: '삭제',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DeleteIcon color={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y' ? "error" : "grey"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y'? false : true } />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            { field: 'id', headerName: 'user_id', width: 0, headerAlign: 'center' },
            { field: 'user_status', headerName: 'user_status', width: 0, headerAlign: 'center' },
            { field: 'workplace_id', headerName: 'workplace_id', width: 0, headerAlign: 'center' },
            { field: 'dept_id', headerName: 'dept_id', width: 0, headerAlign: 'center' },
            { field: 'position', headerName: 'position', width: 0, headerAlign: 'center' },
            { field: 'duty', headerName: 'duty', width: 0, headerAlign: 'center' },
            { field: 'user_name', headerName: '이름', width: 150, headerAlign: 'center', align:'left' },
            { field: 'emp_no', headerName: '사번', width: 120, headerAlign: 'center', align:'center' },
            { field: 'user_status_name', headerName: '상태', width: 80, headerAlign: 'center', align:'center' },
            { field: 'workplace_name', headerName: '사업장', width: 170, headerAlign: 'center', align:'left' },
            { field: 'dept_nm', headerName: '부서', width: 120, headerAlign: 'center', align:'center' },
            { field: 'position_nm', headerName: '직위', width: 120, headerAlign: 'center', align:'center' },
            { field: 'duty_nm', headerName: '직책', width: 120, headerAlign: 'center', align:'center' },
            { field: 'user_email', headerName: '이메일', width: 250, headerAlign: 'center', align:'left' },
            { field: 'user_phone', headerName: '휴대폰번호', width: 170, headerAlign: 'center', align:'center' },
            { field: 'user_call', headerName: '전화번호', width: 170, headerAlign: 'center', align:'center' },
            { field: 'user_en_name', headerName: '영문이름', width: 200, headerAlign: 'center', align:'left' }
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        user_status: false,
        workplace_id: false,
        dept_id: false,
        position: false,
        duty: false,
        user_name: true,
        emp_no: true,
        user_status_name: true,
        workplace_name: true,
        dept_nm: true,
        position_nm: true,
        duty_nm: true,
        user_email: true,
        user_phone: true,
        user_call: true,
        user_en_name: true,
        deleted: true,
        updated: true
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> MenuID 가 0이면 아직 권한 체크가 되지 않았으므로, 권한 체크 후 조회.
        // keyword가 변경되면 조회.
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword]);

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> 권한체크가 되면 MenuID가 변경되므로, 권한체크 후 Grid 설정.
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleInit();
            handleView();
        }
    }, [MenuID]);
    
    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/User/List',
            {
            params : {
              workplace: keyword.workplace_id,
              dept : keyword.dept_id,
              position : keyword.position,
              duty : keyword.duty
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            const PermissionMap = {};
            response.data.forEach(row => {
                if (!PermissionMap[row.user_id]) {
                    PermissionMap[row.user_id] = [row.reg_user_id, row.update_user_id].includes(Number(localStorage.getItem('user_id')));
                }
            });

            const array = response.data.map((item, index) => ({
                id: item.user_id,
                user_status: item.user_status,
                workplace_id: item.workplace_id,
                dept_id: item.dept_id,
                position: item.position,
                duty: item.duty,
                user_name: item.user_name,
                emp_no: item.emp_no,
                user_status_name: item.user_status_name,
                workplace_name: item.workplace_name,
                dept_nm: item.dept_nm,
                position_nm: item.position_nm,
                duty_nm: item.duty_nm,
                user_email: item.user_email,
                user_phone: item.user_phone,
                user_call: item.user_call,
                user_en_name: item.user_en_name,
                update_flag: PermissionMap[item.user_id] ? 'Y' : 'N'
            }));
            setOriginRows(response.data);
            setRows(array);
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false);
        });

    }

    const handleInitSelect = () => {
        //사업장
        axios.get('/api/Common/WorkplaceList')
        .then((response) => {
            var array = response.data.map((item, index) => 
                ({ value: item.workplace_id, label: item.workplace_name })
            );
            var array_modal = response.data.map((item, index) => 
                ({ value: item.workplace_id, label: item.workplace_name })
            );
            array.unshift({ value: 0, label : '사업장'});
            
            setWorkplaceOption(array);
            setWorkplaceModalOption(array_modal);
        })
        .catch((error) => {
            console.log(error);
        });

        //부서
        axios.get('/api/Common/DeptList')
        .then((response) => {
            var array = response.data.map((item, index) => 
                ({ value: item.dept_id, label: item.dept_name })
            );
            var array_modal = response.data.map((item, index) => 
                ({ value: item.dept_id, label: item.dept_name })
            );
            array.unshift({ value: 0, label : '부서'});

            setDeptOption(array);
            setDeptModalOption(array_modal);
            
        })
        .catch((error) => {
            console.log(error);
        });

        //직위, 직책, 은행
        axios.get('/api/Common/CodeDetailList')
        .then((response) => { 

            var position_array = [];
            var duty_array = [];
            var bank_array = [];
            var position_array_modal = [];
            var duty_array_modal = [];
            for(let i=0; i<(response.data).length; i++){
                if((response.data)[i].code_id === '0003'){
                    position_array.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                    position_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }else if((response.data)[i].code_id === '0004'){
                    duty_array.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                    duty_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }else if((response.data)[i].code_id === '0006'){
                    bank_array.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }
            }
            position_array.unshift({ value: 0, label : '직위'});
            duty_array.unshift({ value: 0, label : '직책'});
            bank_array.unshift({ value: 0, label : '은행'});

            setPositionModalOption(position_array_modal);
            setPositionOption(position_array);
            setDutyModalOption(duty_array_modal);
            setDutyOption(duty_array);
            setBankOption(bank_array);
            setBankModalOption(bank_array);
        })
        .catch((error) => {
            console.log(error);
        });        
    }

    const handleInit = () => {
        setKeyword({
            workplace_id: 0,
            dept_id: 0,
            position: 0,
            duty: 0
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            user_status: false,
            workplace_id: false,
            dept_id: false,
            position: false,
            duty: false,
            user_name: true,
            emp_no: true,
            user_status_name: true,
            workplace_name: true,
            dept_nm: true,
            position_nm: true,
            duty_nm: true,
            user_email: true,
            user_phone: true,
            user_call: true,
            user_en_name: true,
            deleted: true,
            updated: true,
            update_flag: false
        });
    };

    const handleReg = () => {
        setRegModalOpen(true);
        setModalTitle('사용자 등록');
    };
    
    const UpdateClick = (object) => {
        setUpdateModalOpen(true);
        setModalTitle('사용자 수정');
        setSelectUserID(object.row.id);
    };

    const DeleteClick = (object) => {
        Swal.fire({
            title: '사용자 '+object.row.user_name+' 삭제',
            html : '사용자 '+object.row.user_name+'을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton : true,
            confirmButtonColor : "#d33",
            confirmButtonText : "삭제",
            cancelButtonText : "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);

                axios.post('/api/p/User/Delete', new URLSearchParams({
                    delete_user_id: object.row.id
                }),
                { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){
                        Swal.fire({
                            title: '사용자 '+object.row.user_name+' 삭제 완료',
                            text: '정상적으로 사용자 '+object.row.user_name+'가 삭제 되었습니다.',
                            confirmButtonText: '확인',
                            timer: 5000,
                            timerProgressBar: true
                        }).then((result) => {
                            setRows((rows) => rows.filter((data) => data.id !== object.row.id));
                        });
                    }else{
                        appStore.capture();
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .finally(() => {
                    appStore.setLoading(false);
                });
            }
        });
    };

    const onSelectChange = (type, value) => {
        const nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const handleRegSuccessSave = (regID) => {
        setModalTitle('사용자 수정');
        setRegModalOpen(false);
        handleView();
        Swal.fire({
            title: '사용자 등록 완료',
            text: '정상적으로 사용자가 등록 되었습니다.',
            confirmButtonText: '확인',
            timer: 5000,
            timerProgressBar: true
        }).then((result) => {
            // 수정 화면 불러오기
            setUpdateModalOpen(true);
            setSelectUserID(Number(regID));
        });
    };

    const handleExcel = () => {
        var filename = '사용자관리'
        axios.get('/api/p/User/Excel',
        {   
            params : {
                workplace: keyword.workplace_id,
                dept : keyword.dept_id,
                position : keyword.position,
                duty : keyword.duty,
                file_name: filename
            },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    { MenuUpdateYN === "Y"?
                    <Button 
                        onClick={ handleReg }
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                    </Button> : <></> }
                    {isRegModalOpen  && MenuUpdateYN === 'Y' && (
                        <UserRegModal
                        onClose={() => {
                            setRegModalOpen(false);
                        }}
                        title={modalTitle}
                        handleRegSuccessSave={handleRegSuccessSave}
                        deptModalOption={deptModalOption}
                        workplaceModalOption={workplaceModalOption}
                        positionModalOption={positionModalOption}
                        dutyModalOption={dutyModalOption}
                        bankModalOption={bankModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            사업장
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="사업장" onChange={(e) => onSelectChange('workplace_id',e.value)} value={workplaceOption.filter(function (option) { return option.value === keyword.workplace_id;  })} options={workplaceOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            부서
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="부서" onChange={(e) => onSelectChange('dept_id',e.value)} value={deptOption.filter(function (option) { return option.value === keyword.dept_id;  })} options={deptOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            직위
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="직위" onChange={(e) => onSelectChange('position', e.value) } value={positionOption.filter(function (option) { return option.value === keyword.position;  })} options={positionOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            직책
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="직책" onChange={(e) => onSelectChange('duty', e.value)} value={dutyOption.filter(function (option) { return option.value === keyword.duty;  })} options={dutyOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="grid_sub" style={ { width: '100%', fontSize: '17px' } }>
                    <DataGrid
                        className="grid_main"
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                    />
                    {isUpdateModalOpen && (
                        <UserUpdateModal
                        onClose={() => {
                            setUpdateModalOpen(false);
                        }}
                        title={modalTitle}
                        id={selectUserID}
                        originRows={originRows.filter(row => String(row.user_id) === String(selectUserID))}
                        handleView={handleView}
                        deptModalOption={deptModalOption}
                        workplaceModalOption={workplaceModalOption}
                        positionModalOption={positionModalOption}
                        dutyModalOption={dutyModalOption}
                        bankModalOption={bankModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default User;
